import { FC } from 'react';
import Button from '@components/common/button';
import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    onClick: () => void;
}

// Shared "Report problem" action button used across all transaction detail modals
// (view_transaction, view_card_transaction, view_external_transaction). Renders the
// Figma outline-pill spec (node 19452:265351: 1px var(--error-40) border, 100px
// radius, transparent fill, red text) via Button's own `outlined-red` variant.
// Width/height come from each modal's action-bar layout: when Report is the LONE
// action it renders as a CONTAINED 320×48 centered pill (`.actions > button
// :only-child`, matching the Figma Dashboard-UI frame); in the Decline/Approve
// multi-button layouts it sits auto-width alongside the primary buttons.
const ReportProblemButton: FC<IProps> = ({ onClick }) => {
    const { submitLocale } = useLocales();

    return (
        <Button variant="outlined-red" size="medium" onClick={onClick}>
            {submitLocale('report_problem')}
        </Button>
    );
};

export default ReportProblemButton;
